import React, { useState } from "react"
import { Modal } from "../components/design-system/Modal"
import { CopyButton } from "../components/CopyButton"

export const useShareModal = () => {
  const [isModalVisible, setIsModalVisible] = useState(false)

  return [
    <Modal isOpen={isModalVisible} handleClose={() => setIsModalVisible(false)}>
      <h1>Share or share wallet</h1>
      <p>Copy this link to save your wallet and to come back to it anytime, or share it with others</p>
      <h4 style={{ marginBottom: 0 }}>Your personalized wallet link:</h4>
      <a
        style={{
          wordWrap: 'break-word',
          wordBreak: 'break-all',
          overflowWrap: 'anywhere',
          maxWidth: '100%',
          display: 'inline-block',
        }}
        target="_blank"
        rel="noreferrer"
        href={window.location.href}
      >
        {window.location.href}
      </a>
      <CopyButton textToCopy={window.location.href} />
    </Modal>,
    () => setIsModalVisible(true),
  ] satisfies [React.ReactElement, () => void];
}